export default function PreviewContact({ config }) {
  const c = config?.website?.contact || {};
  const theme = config?.theme || {};
  const primary = theme.primary || "#9df03d";
  const onPrimary = theme.onPrimary || "#05070a";

  return (
    <section style={{ padding: "0 24px 26px" }}>
      <div
        style={{
          borderRadius: "var(--ns-radius-xl)",
          background: "var(--ns-card)",
          border: "1px solid var(--ns-card-border)",
          boxShadow: "var(--ns-shadow)",
          padding: 18
        }}
      >
        <h3 style={{ margin: 0, color: "var(--ns-ink)", fontWeight: 950, fontSize: 18 }}>
          Contact & Location
        </h3>

        <div
          style={{
            marginTop: 14,
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: 12
          }}
        >
          <InfoCard label="Phone" value={c.phone} />
          <InfoCard label="WhatsApp" value={c.whatsapp} />
          <InfoCard label="Email" value={c.email} />
          <InfoCard label="Website" value={c.website} />
        </div>

        <div style={{ marginTop: 12 }}>
          <InfoCard label="Address" value={c.address} full />
        </div>

        <div style={{ marginTop: 14, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
          <button
            type="button"
            style={{
              borderRadius: 999,
              padding: "12px 16px",
              border: "none",
              cursor: "pointer",
              fontWeight: 950,
              background: `linear-gradient(180deg, ${primary}, rgba(0,0,0,0.12))`,
              color: onPrimary,
              boxShadow: "0 14px 30px rgba(15,23,42,0.14)"
            }}
            onClick={() => c.mapUrl && window.open(c.mapUrl, "_blank")}
            disabled={!c.mapUrl}
          >
            Get Directions
          </button>

          <span style={{ color: "rgba(11,18,32,0.55)", fontSize: 12 }}>
            {c.mapUrl ? "Opens Google Maps" : "Add Map URL to enable"}
          </span>
        </div>
      </div>
    </section>
  );
}

function InfoCard({ label, value, full }) {
  return (
    <div
      style={{
        padding: 16,
        borderRadius: 16,
        background: "rgba(15,23,42,0.03)",
        border: "1px solid rgba(15,23,42,0.08)",
        gridColumn: full ? "1 / -1" : undefined
      }}
    >
      <div style={{ color: "rgba(11,18,32,0.55)", fontSize: 12, marginBottom: 6, fontWeight: 800 }}>
        {label}
      </div>
      <div style={{ color: "var(--ns-ink)", fontWeight: 950 }}>
        {value || <span style={{ color: "rgba(11,18,32,0.35)" }}>Not set</span>}
      </div>
    </div>
  );
}
